import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from '../../assets/icons';
import { useI18n } from '../../i18n';
import ctaImage from '../../image/image.png';

interface FinalCTAProps {
  onGetInTouchClick: () => void;
}

export const FinalCTA: React.FC<FinalCTAProps> = ({ onGetInTouchClick }) => {
  const { t } = useI18n();

  return (
    <section className="py-24 px-6 md:px-12">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-0 rounded-3xl overflow-hidden border border-white/10">
          {/* Left — Text content */}
          <motion.div
            className="flex flex-col justify-center px-10 md:px-14 py-16 bg-white/[0.02]"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, ease: [0.25, 0.1, 0.25, 1] }}
          >
            <h2 className="font-display text-3xl sm:text-4xl md:text-4xl lg:text-5xl text-white leading-tight mb-8">
              {t.finalCta.subtitle}
            </h2>

            <p className="text-white/50 text-lg mb-10 leading-relaxed">
              {t.finalCta.title}
            </p>

            <div>
              <button
                onClick={onGetInTouchClick}
                className="group inline-flex items-center gap-3 px-8 py-4 rounded-full bg-white hover:bg-white/95 text-gray-900 font-semibold text-lg transition-all duration-300 hover:scale-[1.03] shadow-2xl"
              >
                <span>{t.finalCta.cta}</span>
                <div className="flex items-center justify-center w-9 h-9 rounded-full bg-gray-900 transition-transform group-hover:translate-x-0.5">
                  <ArrowRightIcon className="w-4 h-4 text-white" />
                </div>
              </button>
            </div>
          </motion.div>

          {/* Right — Image */}
          <motion.div
            className="relative min-h-[350px] md:min-h-[480px] overflow-hidden"
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.15, ease: [0.25, 0.1, 0.25, 1] }}
          >
            <img
              src={ctaImage}
              alt=""
              className="absolute inset-0 w-full h-full object-cover"
              style={{ objectPosition: 'center 40%' }}
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};
